import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Link from "@mui/material/Link";
import { useHistory } from "react-router-dom";
import React from "react";
import { UserContext } from "../../hooks/UserContext";

export default function TimeOutDialog(props) {
	const { setUser } = React.useContext(UserContext);
	let history = useHistory();

	const doLogout = () => {
		sessionStorage.clear();
		setUser(null);
		history.push("/login");
	};

	return (
		<Dialog
			open={props.open}
			disableEscapeKeyDown
			maxWidth="xs"
			aria-labelledby="form-dialog-title"
			className="timeoutDialog"
			sx={{
				"&.MuiDialog-root": {
					zIndex: "999999",
				},
			}}
		>
			<DialogContent dividers>
				<DialogContentText id="alert-dialog-description">
					Your Session has been timeout. Please{" "}
					<Link
						href="#"
						color="primary"
						underline="always"
						onClick={() => {
							doLogout();
						}}
					>
						click here
					</Link>{" "}
					to re-login.
				</DialogContentText>
			</DialogContent>
		</Dialog>
	);
}
